<template>
    <form class="login" v-bind:action="apiUrl + '/login'" v-on:submit.prevent="handleSubmit">
        <h3 class="has-margin-b30">{{ __('Sign In') }}</h3>
        <div class="form__group" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Email') }}</label>
            <input class="form__control is-large dark-color" id="email" type="email" autocomplete="off" placeholder="Your email here"
                   v-model="email"
            />
            <small class="form__error_nm" v-if="errors.email">{{ errors.email[0] }}</small>
        </div>
        <div class="form__group" v-bind:class="{ 'has-error' : errors.password }">
            <label class="form__label" for="password">{{ __('Password') }}</label>
            <input class="form__control is-large dark-color" id="password" type="password" autocomplete="off" placeholder="Your password here"
                   v-model="password"
            />
            <small class="form__error_nm" v-if="errors.password">{{ errors.password[0] }}</small>
        </div>

        <div class="is-clearfix">

            <div class="d-inline-block">
                <a class="login__forgot-password-link"
                             v-on:click="showForgotPassword"
                >
                    {{ __('Forgot password?') }}
                </a> <br />
                {{ __('Need an account?') }}
                <a class="login__register-link"
                   v-on:click="showRegistration"
                >
                    {{ __('Sign up here.') }}
                </a>
            </div>
            <button class="btn is-full-width is-primary has-margin-t30" type="submit">{{ __('Sign in') }}</button>
        </div>

        <span class="view__separator dark-color"><span>{{ __('or') }}</span></span>

        <a class="btn btn--facebook-login" v-on:click="handleSocialLogin('facebook')">
            <span class="jam jam-facebook is-circle"></span>
            {{ __('Sign in with Facebook') }}
        </a>
        <a class="btn btn--google-login" v-on:click="handleSocialLogin('google')">
            <span class="jam jam-google"></span>
            {{ __('Sign in with Google') }}
        </a>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                email: '',
                errors: {},
                password: ''
            }
        },
        methods: {
            handleSocialLogin: function (provider) {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/login/social/' + provider).then(function (response) {
                    window.location.replace(response.body.url);
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleSubmit: function (e) {
                const form = e.target;
                const action = form.getAttribute('action');

                eventBus.$emit('show-loader');

                this.$http.post(action, {
                    email: this.email,
                    password: this.password
                }).then(function (response) {
                    this.loginUser(response.body);

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    if (response.status == 429 && response.body.errors) {
                        this.errors = response.body.errors;

                        eventBus.$emit(
                                'show-alert',
                                'error',
                                response.body.errors.email[0]
                        );
                    }

                    eventBus.$emit('hide-loader');
                });
            },
            showForgotPassword: function () {
                this.$parent.showForgotPassword();
            },
            showRegistration: function () {
                this.$parent.showRegistration();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LoginSidebar.vue